import { CampaignType, Field, FormSetting, Page, Platform, SelectableFieldValue } from 'scripts/type'

export type PreviewField = {
  value: number | string | SelectableFieldValue
  fieldCode?: string
}

export type XFormProps = {
  field: Field
  formSetting: FormSetting
  onFieldChange: (data: PreviewField | number) => void
  onFieldHeightChange: (height: number) => void
  onClose: () => void
  type?: CampaignType
  fields?: any[]
  pages?: Page[]
  startIndex: number
  totalCount: number
  interactive?: boolean
  editingFieldIndex?: number
  forcePlatformAs?: Platform
  onAutoClose: () => void
  editingCode?: string
  onFieldClick?: (code: string) => void
  activePageIndex?: number
  isUrlVisit?: boolean
  widget: Widget
}

type Widget = {
  width?: WidgetWidth
}

export enum WidgetWidth {
  SMALL = 'SMALL',
  NORMAL = 'NORMAL',
  LARGE = 'LARGE',
  XLARGE = 'XLARGE',
}
